import {combineReducers} from 'redux'
import {i18nState} from 'redux-i18n'

const appReducer = combineReducers({
    i18nState,
})

export default appReducer